export default {
	Login: '/login',
	Logout: '/logout',
	CreateAccount: {
		Landing: '/create-account',
		Verify: '/create-account/verify',
	},
	ForgotPassword: '/forgot-password',
	ResetPassword: '/reset-password',
	OAuth: (provider: string) => `/oauth/${provider.toLowerCase()}`,
	OAuthCallback: (provider: string) => `/oauth/${provider.toLowerCase()}/callback`,
	Account: {
		Landing: '/account',
		Orders: {
			Landing: '/account/orders',
			View: (orderId: string) => `/account/orders/${orderId}`,
			RefundReceipt: (orderId: string, refundId: string) => `/account/orders/${orderId}/refund/${refundId}.pdf`,
		},
		Designs: {
			Landing: '/account/designs',
			View: (designId: string) => `/account/designs/${designId}`,
		},
		Merch: {
			Landing: '/account/merch',
			View: (merchId: string) => `/account/merch/${merchId}`,
		},
		Settings: '/account/settings',
		Billing: '/account/billing',
		Partner: '/account/partner',
	},
} as const;
